import React, { Component } from "react";
import _ from "lodash";
import ReactLoading from "react-loading";
import ShowtimesSearch from "./components/ShowtimesSearch";
import CinemaSearch from "./components/CinemaSearch";
import ShowtimesResults from "./components/ShowtimesResults";
import CinemaShowtimesResults from "./components/CinemaShowtimesResults";
import CinemaResults from "./components/CinemaResults";
import SelectToggle from "./components/SelectToggle";
import SubscribeForm from "./components/SubscribeForm";
import track from "./lib/tracking";
import "./styles/App.css";
import "./styles/Results.css";
import HubspotForm from 'react-hubspot-form'



class App extends Component {
  state = {
    currentPage: "showtimes",
    savedCinemaId: 0,
    results: {},
    status: "",
    error: "",
    increment: 0,
    blocked: true,
  };

  constructor(props) {
    super(props);
    const cookies = document.cookie.split("; ");
    const subscribed = cookies.find(o => o.includes("subscribed"));
    const isSubscribed = !!subscribed && subscribed.split("=")[1] != "";
    const status = cookies.find(o => o.includes("status"));
    const hasUsed = !!status && status.split("=")[1] != "";
    const isGruvi = window.location.search.includes("gruvi");
    this.state.isGruvi = isGruvi;
    this.state.blocked = !(isGruvi || isSubscribed || !hasUsed);
    if (isSubscribed) {
      this.sendDataToSheets({ revisited: subscribed.split("=")[1] })
    }

  }


  changePage = page => {
    this.setState({ currentPage: page, results: {} });
    track("search_option", { currentPage: page });
  };

  sendDataToSheets = (data) => {
    fetch('https://9n0or3dsik.execute-api.eu-west-2.amazonaws.com/dev', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(response => {
    });

  }
  onFormSubmit = (data) => {
    this.setStatus("loading");
    fetch('https://9n0or3dsik.execute-api.eu-west-2.amazonaws.com/dev', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(response => {
      this.setState({ blocked: false, status: "" });
      document.cookie = `subscribed=${data.email};path=/`;
    });

  }
  searchWithCinema = cinema => {

    this.setState({ status: "loading" });
    const headers = new Headers();
    headers.append("x-api-key", "c87bfbb769147aa04b3390a81dd07e5d");
    fetch(
      "https://api.internationalshowtimes.com/v4/showtimes?lang=en&append=movies&movies=id,name&cinema_id=" + cinema.id,
      {
        headers: headers
      }
    )
      .then(response => response.json())
      .then(responseJson => {
        if (responseJson.showtimes.length === 0) {
          this.setState({
            status: "error",
            error: "Sorry, no results matched your search."
          });
          return;
        }
        const movies = _.keyBy(responseJson.movies, "id");
        this.setResults({
          showtimes: responseJson.showtimes,
          movies,
          cinema: cinema,
        });
        this.setState({ status: "" });
      });
    this.setState({ currentPage: "cinema-showtimes", savedCinemaId: cinema.id });
  };


  setResultsPage = currentPage => this.setState({ currentPage });
  setResults = results => this.setState({ results });

  getSearch = () => {
    switch (this.state.currentPage) {
      case "showtimes":
        return (
          <ShowtimesSearch
            setResults={this.setResults}
            cinemaId={this.state.savedCinemaId}
            setStatus={this.setStatus}
            setResultsPage={this.setResultsPage}
            isGruvi={this.state.isGruvi}
          />
        );
      case "cinema-showtimes":
        return (
          <ShowtimesSearch
            setResults={this.setResults}
            cinemaId={this.state.savedCinemaId}
            setStatus={this.setStatus}
            setResultsPage={this.setResultsPage}
          />
        );
      case "cinemas":
        return <CinemaSearch
          setResults={this.setResults}
          setStatus={this.setStatus}
        />;
      default:
        return <div>error</div>;
    }
  };

  setStatus = (status, error) => {
    this.setState({ status, error });
  }

  getMessage = () => {
    switch (this.state.status) {
      case "loading":
        return (
          <ReactLoading type="spin" color="#5BBADF" height={90} width={90} />
        );
      case "error":
        return <div className="error">{this.state.error}</div>;
      default:
        return null;
    }
  };

  getPage = () => {
    switch (this.state.currentPage) {
      case "cinema-showtimes":
        return <CinemaShowtimesResults results={this.state.results} />;
      case "showtimes":
        return <ShowtimesResults results={this.state.results} />;
      case "cinemas":
        return (
          <CinemaResults
            results={this.state.results}
            searchWithCinema={this.searchWithCinema}
          />
        );
      default:
        return <div>error</div>;
    }
  };

  getMainPage = () => {

    switch (this.state.page) {
      case "about":
        return (
          <div className="about-us">
            <div style={{ marginTop: "20px", marginBottom: "20px", textAlign: "justify", textWeight: "bold" }}>
              Hi, We built Counter Programming to help you with your programming decisions. We know the next few months are crucial for the Industry so use this tool to ensure that timings with your films are not overlapping with your competitors. Over the coming months we will be adding features and upgrades to improve the tool - <a onClick={() => this.setState({ page: "contact" })}>please leave feedback or ideas here if there is a something you feel is important but missing</a>.
            </div>
            <div style={{ marginTop: "20px", marginBottom: "20px", textAlign: "justify", textWeight: "bold" }}>
              <img src="https://s3.amazonaws.com/gruvi-temp/gruvi.tv/gruvi2.svg" alt="Gruvi" />
              <div>
                Gruvi is a marketing technology platform that helps entertainment companies reach and engage online global audiences prior to and during a film's release. Our customers include Disney, Odeon, Viasat and Dreamworks. Gruvi helps you:
              </div>
              <ul>
                <li><b>Plan</b> - through testing and research to define your audiences and how to reach them</li>
                <li><b>Build</b> - a wide range of rich interactive advertising units that include ticketing, video and promotions</li>
                <li><b>Deploy</b> - these units programmatically via our advertising exchanges to all major platforms and social media</li>
                <li><b>Track</b> - how the advertising is performing and how the audiences are moving through to ticketing</li>
                <li><b>Aggregate</b> - user data for the future</li>
              </ul>
            </div>
            <div style={{ marginTop: "20px", marginBottom: "20px", textAlign: "justify", textWeight: "bold" }}>
              <img src="/1.png" />
              <div style={{ marginTop: "20px", marginBottom: "20px", textAlign: "justify" }}>
                The simple to use International Showtimes API provides full sets of cinema, movie & showtime data, for over 47 countries (and growing!), which includes 25,000+ cinemas worldwide- running over 1 billion showtimes every day. The API focuses on providing the best coverage for data sets with accuracy and speed and uses an 'automated aggregation algorithm', which monitors the data 24/7, fact-checks and updates every 2 hours i.e. Showtimes Freshness!
                Movie distributors, exhibitors and cinema theaters can build reliable digital applications, with the feed from International Showtimes API, to efficiently promote their titles to global audiences. The API helps cinema & movie applications and digital publishers deliver a stunning user experience.
                In addition, the API can also be used to build analytical products to gain insights about moviegoer habits and preferences. Many innovative businesses have been using this API to power their digital platforms, movie applications, Intelligent life assistants as well as running targeted marketing campaigns around the world.
                Unlike their competitors, International Showtimes also includes Deep Booking links (powered by AI), Cinema websites & geo-location data as well as additional movie format information (such as Dolby Atmos, D-BOX, Sony 4K, HFR, 4DX etc.) to provide the best showtimes API in the world.
              </div>
            </div>
          </div>
        );
      case "contact":
        return (
          <div>
            <h2>Get in contact with us</h2>
            <div styles={{ marginBottom: "40px" }}>
              <HubspotForm
                portalId='3477242'
                formId='77acffe1-1ff8-4d89-89c1-9d9ac443f478'
                onSubmit={() => console.log('Submit!')}
                onReady={(form) => console.log('Form ready!')}
                loading={<div>Loading...</div>}
              />
            </div>
          </div>
        );
      case "demo":
        return (
          <div className="demo">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/WbVkofyh6Oo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        );
      default:
        return this.state.blocked ? (this.state.status === "loading" ? <div className="loading"><ReactLoading type="spin" color="#5BBADF" height={90} width={90} /></div> : <SubscribeForm onFormSubmit={this.onFormSubmit} />) : (
          <div className="main">
            <div>
              <div className="search box rounded">
                <div className="menu--header">Check your competitors play week around each of your cinemas</div>
                {this.state.isGruvi ? <SelectToggle
                  classes={[
                    "flex-row",
                    "children-flex-1",
                    "justify-space-between"
                  ]}
                  selected={this.state.currentPage}
                  options={["showtimes", "cinemas"]}
                  onValueChange={this.changePage}
                /> : <div></div>}
                {this.getSearch()}
              </div>
              <div className="feedback"><a onClick={() => this.setState({ page: "contact" })} >Ideas or feedback?</a></div>
            </div>
            <div className="message">
              {this.getMessage()}
              {this.getPage()}
            </div>
          </div>
        );
    }
  }

  render() {
    return (
      <div>
        <header className="page-header">
          <div className="page-header--section page-header--icon">
            <a target="_blank" href="https://gruvi.tv"><img alt="Gruvi" src="https://s3.amazonaws.com/gruvi-temp/gruvi.tv/gruvi2.svg" /></a>
            <button onClick={() => this.setState({ page: "home" })} className="header-button">Showtimes</button>
            <button onClick={() => this.setState({ page: "about" })} className="header-button">About</button>
            <button onClick={() => this.setState({ page: "contact" })} className="header-button">Feedback</button>
            <button onClick={() => this.setState({ page: "demo" })} className="header-button">Demo</button>
          </div>
        </header>
        <div className="App">
          <h1 className="title">The Counter Programming Research Tool ( Beta )</h1>
          {this.getMainPage()}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js